module.exports = __webpack_public_path__ + "img/fondo_login.6992d437.png";